import AddBook from "components/AddBook";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter as Router, useHistory } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import { Toaster } from "react-hot-toast";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Routes from "Routes";
import AuthModal from "components/v2/Auth/AuthModal";
import AddUser from "components/AddUser";
import AddCategory from "components/AddCategory";
import AddCollection from "components/AddCollection";
import AddSubscriptionPlan from "components/AddSubscriptionPlan";
import AddRate from "components/AddRate";
import AddSubjectGroup from "components/AddSubjectGroup";
import UploadUsers from "components/UploadUsers";

import CurrencyBootstrap from "components/CurrencyBootstrap";

const queryClient = new QueryClient();

const App = () => {
	const history = useHistory();
	const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

	const app = (
		<Router history={history}>
			<QueryClientProvider client={queryClient}>
                <CurrencyBootstrap />
				<ToastProvider
					autoDismiss
					autoDismissTimeout={2000}
					placement="top-center"
				>
					<Router>
						<Routes />
						<AuthModal />
					</Router>
					<AddBook />
					<AddUser />
					<AddCategory />
					<AddCollection />
					<AddSubscriptionPlan />
					<AddRate />
					<UploadUsers />
					<AddSubjectGroup />
					<Toaster
						toastOptions={{
							style: { zIndex: "99999" },
							success: {
								className:
									"text-akgreenest border border-gray-200 rounded-full",
							},
							error: {
								className: "text-red-700 border border-gray-200 rounded-full",
							},
						}}
					/>
				</ToastProvider>
			</QueryClientProvider>
		</Router>
	);

	if (!googleClientId) {
		return app;
	}

	return (
		<GoogleOAuthProvider clientId={googleClientId}>
			{app}
		</GoogleOAuthProvider>
	);
};

export default App;
